function Circle({ className }: any) {
  return (
    <svg
      className={`${className}`}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      preserveAspectRatio="xMidYMid meet"
      stroke="currentColor"
      fill="currentColor"
    >
      <circle cx="18" cy="18" r="18"></circle>
    </svg>
  );
}

export default Circle;
